import React, { useContext } from "react";
import { Grid, IconButton, Stack } from "@mui/material";
import styled from "styled-components";
import InfoIcon from "@mui/icons-material/Info";
import InvestmentSection from "src/scenes/overview/overview-components/main-sections/investment-section";
import DevCost from "src/scenes/overview/overview-components/main-sections/dev-cost";
import CodeCost from "src/scenes/overview/overview-components/main-sections/code-cost";
import DeliverySectionOutput from "src/scenes/overview/overview-components/main-sections/delivery-section";
import DeliverySectionEfficacy from "src/scenes/overview/overview-components/main-sections/delivery-section-efficacy";
import { OverviewContext } from "src/components/providers/overview-provider";
import OverviewRefreshSection from "src/scenes/overview/overview-components/overview-refresh-section";

const SectionTitle = styled.p`
    font-size: 16px;
    font-weight: 600;
`;

const OverviewMain = () => {
    const [isInvestmentFlipped, setIsInvestmentFlipped] = React.useState(false);
    const [isDeliveryFlipped, setIsDeliveryFlipped] = React.useState(false);
    const [isExpenditureFlipped, setIsExpenditureFlipped] = React.useState(false);

    const { executiveApi, expandedView, setRefresh } = useContext(OverviewContext);
    const data = executiveApi && executiveApi.data;
    const fetchAction = executiveApi;

    return (
        <>
            <Stack direction="row" justifyContent="end" mt={1}>
                <OverviewRefreshSection cachedAt={data && data.cachedAt} setRefresh={setRefresh} />
            </Stack>
            <Grid container spacing={2} justifyContent="center">
                <Grid item md={3.5} sx={{ width: "100%" }}>
                    <Stack direction="column">
                        <Stack direction="row" alignItems="center">
                            <SectionTitle>Investment</SectionTitle>
                            <IconButton
                                size="small"
                                onClick={() => setIsInvestmentFlipped(!isInvestmentFlipped)}
                                aria-label="View info on metrics"
                                color="secondary"
                            >
                                <InfoIcon />
                            </IconButton>
                        </Stack>
                        <InvestmentSection
                            fetchAction={fetchAction}
                            data={data}
                            expandedView={expandedView}
                            isFlipped={isInvestmentFlipped}
                        />
                    </Stack>
                </Grid>
                <Grid item md={3.5} sx={{ width: "100%" }}>
                    <Stack direction="column">
                        <Stack direction="row" alignItems="center">
                            <SectionTitle>Delivery</SectionTitle>
                            <IconButton
                                size="small"
                                onClick={() => setIsDeliveryFlipped(!isDeliveryFlipped)}
                                aria-label="View info on metrics"
                                color="secondary"
                            >
                                <InfoIcon />
                            </IconButton>
                        </Stack>
                        <Stack spacing={2}>
                            <DeliverySectionOutput
                                fetchAction={fetchAction}
                                data={data}
                                expandedView={expandedView}
                                isFlipped={isDeliveryFlipped}
                                setIsFlipped={setIsDeliveryFlipped}
                            />
                            <DeliverySectionEfficacy
                                fetchAction={fetchAction}
                                data={data}
                                expandedView={expandedView}
                                isFlipped={isDeliveryFlipped}
                                setIsFlipped={setIsDeliveryFlipped}
                            />
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item md={5} sx={{ width: "100%" }}>
                    <Stack direction="column">
                        <Stack direction="row" alignItems="center" justifyContent="flex-start">
                            <SectionTitle>Credit Expenditure</SectionTitle>
                            <IconButton
                                size="small"
                                onClick={() => setIsExpenditureFlipped(!isExpenditureFlipped)}
                                aria-label="View info on metrics"
                                color="secondary"
                            >
                                <InfoIcon />
                            </IconButton>
                        </Stack>
                        <Stack spacing={2}>
                            <DevCost
                                fetchAction={fetchAction}
                                data={data}
                                expandedView={expandedView}
                                isFlipped={isExpenditureFlipped}
                                setIsFlipped={setIsExpenditureFlipped}
                            />
                            <CodeCost
                                fetchAction={fetchAction}
                                data={data}
                                expandedView={expandedView}
                                isFlipped={isExpenditureFlipped}
                                setIsFlipped={setIsExpenditureFlipped}
                            />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};

export default OverviewMain;
